//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      dateList:[],
      dateIndex:0,
    }
  },
  methods:{
    switchTabItem (index) {
      this.$emit('notice-select',this.dateList[index],index)
      // console.log('on-before-index-change', index)
      // this.$vux.loading.show()
      // setTimeout(() => {
      //   this.$vux.loading.hide()
      //   this.dateIndex = index
      // }, 500)
    },
    getDay(d,t){
      let month = d.getMonth()+1
      let date = d.getDate()
      let day = d.getDay()
      let arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")
      return{
        date:(month <10?'0'+month:month) + '月' +(date <10?'0'+date:date)+"日",
        day:(t.length > 0?t:arr_week[day]),
        year:d.getFullYear()
      }
    }
  },
  mounted(){
    this.dateList = []
    let now = new Date()
    this.dateList.push(this.getDay(now,'今天'))
    for(let i=0;i<13;i++){
      now.setDate(now.getDate() + 1);
      this.dateList.push(this.getDay(now,i==0?'明天':''))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tabDate/index.vue